<template>
  <div class="set-padding pt-2">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  created: function () {
    },
}
</script>
<style scoped>
  .set-padding{
    padding-left: 10% !important;
    padding-right: 10% !important;
  } 
</style>